import { Component, OnInit, Input } from '@angular/core';
import { faCircleNotch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toast.service';
import { UsersService } from 'src/app/services/users.service';
import { DeactivateAcceptComponent } from '../../notify/deactivate-accept/deactivate-accept.component';

@Component({
  selector: 'app-deactivate-account',
  templateUrl: './deactivate-account.component.html',
  styleUrls: ['./deactivate-account.component.scss']
})
export class DeactivateAccountComponent implements OnInit {
  @Input() selfModal: NgbModalRef | null = null;
  @Input() user: any = {};

  faTimes = faTimes;
  faCircleNotch = faCircleNotch;
  loading = false;

  constructor(
    private usersService:UsersService,
    private toastService:ToastService,
    private ngbModal: NgbModal,
    ) { }

  ngOnInit(): void {
    // console.log(this.isASuperUser());
  }
  isASuperUser(){
    return (this.user.type == 'manager'); 
  }
  closeModal(){
    if(this.selfModal) this.selfModal?.close();
    else $("ngb-modal-window").click();
  }
  deactivate(){
    this.loading = true;
    this.usersService.patchDeactivateAccount(this.user.id)
        .then((res:any)=>{
          if(res.result == 'success'){
            this.closeModal();
            let modalRef = this.ngbModal.open(DeactivateAcceptComponent, {
              windowClass: 'default-modal',
              size: '600',
              centered: true 
            });
            modalRef.componentInstance.user = { email: this.user.email };
            modalRef.componentInstance.selfModal = modalRef;
            this.loading = false;
          }
          if(res.status == 422){
            this.toastService.showError(res.error.errors.message);
            this.loading = false;
          }
          if (res.status == 401){
            this.toastService.showError(res.error.message.friendly);
            this.loading = false;
          }          
        })
        .catch((err)=>{
          this.toastService.showError(err);
          this.loading = false;
        }) 
  }
}